<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-menu
    v-model="startEndTimeOpen"
    :max-width="520"
    :min-width="520"
    :close-on-content-click="false"
    content-class="UXDatapicker timePicker"
    :disabled="dis"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdatetimeInput outline" :class="{disabled: dis}" v-on="on">
        <span class="inpTxt" v-if="picker !== ''">{{ picker }}</span>
        <span class="inpTxt" v-else>00:00 ~ 00:00</span>
        <i class="UXicon-down"></i>
      </div>
    </template>
    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong>
            <span v-if="startHour || startMinute || endHour || endMinute">
              {{ startHour ? startHour + ' :' : '00 :' }}
              {{ startMinute ? startMinute : '00' }}
              ~
              {{ endHour ? endHour + ' :' : '00 :' }}
              {{ endMinute ? endMinute : '00' }}
            </span>
            <span v-else>時間選択</span>
          </strong>
        </p>
        <div class="endBtn">
          <v-btn outline small class="UXbtn" @click="clearTimePicker(clearStatus)">初期化</v-btn>
          <v-btn dark color="#ff8c8c" :disabled="!(startHour && startMinute && endHour && endMinute)" @click="setTime(clearStatus)">完了</v-btn>
        </div>
      </div>
      <div class="con3">
        <div class="timeBox">
          <div class="startEndHeader">開始時間</div>
          <dl>
            <dd>
              <perfect-scrollbar ref="startHourList">
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a :class="{on: startHour == item}" @click="startHour = item">{{ item }}時</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dd>
              <perfect-scrollbar ref="startMinuteList">
                <ul v-if="!(startHour === 24 || startHour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{on: startMinute == item}" @click="startMinute = item">{{ item }}分</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{on: startMinute == '00'}" @click="startMinute = '00'">00分</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
        <div class="timeBox">
          <div class="startEndHeader">終了時間</div>
          <dl>
            <dd>
              <perfect-scrollbar ref="endHourList">
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a :class="{on: endHour == item}" @click="endHour = item">{{ item }}時</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dd>
              <perfect-scrollbar ref="endMinuteList">
                <ul v-if="!(endHour === 24 || endHour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{on: endMinute == item}" @click="endMinute = item">{{ item }}分</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{on: endMinute == '00'}" @click="endMinute = '00'">00分</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'StartEndTimePicker',
  data () {
    return {
      startEndTimeOpen: false,
      hours: [],
      minutes: [],
      startHour: '',
      startMinute: '',
      endHour: '',
      endMinute: '',
      picker: '',
      clearStatus: false
    }
  },
  props: {
    startTime: {
      type: String
    },
    endTime: {
      type: String
    },
    minuteScope: {
      type: Number
    },
    dis: {
      type: Boolean
    },
    reservation: {
      type: Boolean,
      dafalut: false
    }
  },
  created () {
    const minuteScopeNum = !this.minuteScope ? (this.reservation ? 30 : 5) : this.minuteScope < 60 ? this.minuteScope : (this.reservation ? 30 : 5)
    for (let i = 0; i < 60; i++) {
      let num = i.toString().length > 1 ? i : '0' + i.toString()
      if (this.hours.length < 24 && i >= 0) {
        this.hours.push(num)
      }
      if (i % minuteScopeNum === 0) {
        this.minutes.push(num)
      }
    }
    setTimeout(() => {
      this.resetTime()
    }, 50)
  },
  watch: {
    startTime () {
      this.resetTime()
    },
    endTime () {
      this.resetTime()
    },
    startHour (val) {
      if (Number(val) === 24) {
        this.startMinute = '00'
      }
    },
    endHour (val) {
      if (Number(val) === 24) {
        this.endMinute = '00'
      }
    },
    startEndTimeOpen (val) {
      if (val) {
        setTimeout(() => this.moveScroll(), 300)
      }
    }
  },
  methods: {
    resetTime () {
      if (this.startTime && this.endTime) {
        this.startMinute = this.startTime.split(':')[1] === '59' ? '00' : this.startTime.split(':')[1]
        this.startHour = this.startTime.split(':')[1] === '59' ? Number(this.startTime.split(':')[0]) + 1 : this.startTime.split(':')[0]

        this.endMinute = this.endTime.split(':')[1] === '59' ? '00' : this.endTime.split(':')[1]
        this.endHour = this.endTime.split(':')[1] === '59' ? Number(this.endTime.split(':')[0]) + 1 : this.endTime.split(':')[0]

        this.picker = `${this.startHour}:${this.startMinute} ~ ${this.endHour}:${this.endMinute}`
      } else {
        this.picker = ''
        this.startHour = ''
        this.startMinute = ''
        this.endHour = ''
        this.endMinute = ''
      }
    },
    clearTimePicker (clear) {
      this.picker = ''
      this.startHour = ''
      this.startMinute = ''
      this.endHour = ''
      this.endMinute = ''
      clear = true
      this.setTime(clear)
    },
    moveScroll () {
      const itemSize = 24
      if (this.startTime) {
        this.$refs.startHourList.$el.scrollTop = this.$refs.startHourList ? Number(this.startHour) * itemSize : 0
        this.$refs.startMinuteList.$el.scrollTop = this.$refs.startMinuteList ? Math.floor(this.startMinute / 5) * itemSize : 0
      }
      if (this.endTime) {
        this.$refs.endHourList.$el.scrollTop = this.$refs.endHourList ? Number(this.endHour) * itemSize : 0
        this.$refs.endMinuteList.$el.scrollTop = this.$refs.endMinuteList ? Math.floor(this.endMinute / 5) * itemSize : 0
      }
    },
    setTime (clearStatus) {
      if (clearStatus) {
        let time = {
          start: '',
          end: ''
        }
        this.$emit('child', time)
        this.picker = ''
      } else {
        let time = {
          start: this.startHour + ':' + this.startMinute,
          end: this.endHour + ':' + this.endMinute
        }
        this.$emit('child', time)
        this.picker = time.start + '~' + time.end
      }
      this.startEndTimeOpen = false
    },
    checkTimeValidation () {
      if (this.startHour === this.endHour && this.startMinute === this.endMinute) {
        this.resetTime()
        this.$alertMsg('開始時間と終了時間が同じです。')
        return false
      } else if (
        Number(this.startHour) - Number(this.endHour) > 0 ||
        (Number(this.startHour) - Number(this.endHour) === 0 && Number(this.startMinute) - Number(this.endMinute) > 0)
      ) {
        this.resetTime()
        this.$alertMsg('開始時間が終了時間より遅く設定できません。')
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.timePicker .UXdtpCard .con3 .timeBox dl dd ul {
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/StartEndTimePicker.vue